module.exports = __webpack_public_path__ + "static/media/checkmark-white.25d1830d.svg";